import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { DeviceGroupService } from 'src/app/Service/DeviceGroup/DeviceGroup.service';

@Component({
  selector: 'app-DeviceBehfaActiveList',
  templateUrl: './DeviceBehfaActiveList.component.html',
  styleUrls: ['./DeviceBehfaActiveList.component.scss']
})
export class DeviceBehfaActiveListComponent implements OnInit {

  @Input() inner_PersianDate:string=''
  @Input() inner_Filter:boolean=false
  @Input() inner_SeletedDeviceBehfa: Array<DeviceBehfa_Interface> = []

  @Output() seleted_DeviceBehfa_Interface = new EventEmitter<DeviceBehfa_Interface>();

  page:number=0
  Token: String = ""
  constructor(
    private DeviceBehfa_Service: DeviceBehfaService,
    private DeviceGroup_Service:DeviceGroupService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

    this.Read_First_Device_Group()
  }

  Procssing_DeviceBehfa: boolean = false

  Search_Code_DeviceBehfa_Table: string = ''


  DataList_DeviceBehfa: Array<DeviceBehfa_Interface> = []

  ReadData_DeviceBehfa_KeySearch_Timer: any
  ReadData_DeviceBehfa_KeySearch() {

    if (this.ReadData_DeviceBehfa_KeySearch_Timer) {
      clearTimeout(this.ReadData_DeviceBehfa_KeySearch_Timer);
      this.ReadData_DeviceBehfa_KeySearch_Timer = null;
    }

    this.ReadData_DeviceBehfa_KeySearch_Timer = setTimeout(function () {
      this.ReadData_DeviceBehfa()
    }.bind(this), 1000);

  }

  ReadData_DeviceBehfa() {
    this.Procssing_DeviceBehfa = true
    this.DataList_DeviceBehfa = []

    this.DeviceBehfa_Service.GetSearchBehfaDeviceActive(this.Token,
      this.Search_Code_DeviceBehfa_Table,
      this.inner_PersianDate,
      this.inner_Filter,
      Number(this.First_Device_Group_Selected),
      Number(this.Second_Device_Group_Selected)).subscribe(
        data => {

          this.DataList_DeviceBehfa = data
          this.Procssing_DeviceBehfa = false
        }, error => {
          localStorage.clear()
          location.reload();

        }
      )
  }

  Set_Selected_DeviceBehfa_Record(item: DeviceBehfa_Interface) {
    this.seleted_DeviceBehfa_Interface.emit(item);
  }

  Check_InList(item:DeviceBehfa_Interface)
  {
    for(let detail of this.inner_SeletedDeviceBehfa)
    {
      if(item.code==detail.code)
      {
        return true
      }
    }
    return false
  }


  //#region Device Group

  DataList_First_Device_Group:Array<General_Interface>=[]
  DataList_Second_Device_Group:Array<General_Interface>=[]

  First_Device_Group_Selected:string='0'
  Second_Device_Group_Selected:string='0'

  Read_First_Device_Group(){
    this.DeviceGroup_Service.GetDeviceGroup(this.Token,0).subscribe(
      data=>{
        this.DataList_First_Device_Group=data
      }
    )
  }

  Read_Second_Device_Group(){
    this.Second_Device_Group_Selected="0"
    this.DeviceGroup_Service.GetDeviceGroup(this.Token,Number(this.First_Device_Group_Selected)).subscribe(
      data=>{
        this.DataList_Second_Device_Group=data
      }
    )
  }

  //#endregion


}
